


import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class WildDrop implements GameRoundPresentation {

    private _reelId:number;
    private _wildDrop:boolean [] = [];
    private _wildMultipliers:number [] = [];
    private _hasWin:boolean;
    private _tl:Timeline;
    private _endDelay:number = 0.5;

    private _dropIndex = 4; // Is always last reel
    private _scattersCollectedFSAfter:number = 0;
    private _freespinsAddCounter:number;
    private _firstSpinWildDrop:boolean;

    private _fromMode:string;
    private _toMode:string;
    private _hasDropped:boolean = false;


    constructor(reelId:number) {
        this._reelId = reelId;
        //this._reset = reset;
    }

    public getAnimation():Timeline {
        const tl = new TimelineLite();

        if(this._hasWin && this._reelId === 4 && !this._firstSpinWildDrop) {

            tl.add(
                () => HarlequinGameModuleConfig.harlequinScatterCollectorView.unLock()
            );

            const rtl:Timeline = HarlequinGameModuleConfig.harlequinScatterCollectorView.resetIndicators(0);
            //const htl:Timeline = HarlequinGameModuleConfig.harlequinWalkerView.addAndShowWildDrop(this._dropIndex, this._wildMultipliers);
            tl.add([
                rtl,
                HarlequinGameModuleConfig.harlequinSignView.playMiddleBar("New3ScattersReset"),
                (!this._hasDropped)? () => {
                    if(!this._hasDropped) {
                        this._hasDropped = true;
                        HarlequinGameModuleConfig.harlequinSignView.playRightBar("NewBonusWonToBonusgameActivatingHarlequinDrop");
                    }
                } : () => {}
            ]);
            tl.add([

                //htl,
                //HarlequinGameModuleConfig.harlequinSignView.playRightBar("NewBonusWonToBonusgameActivatingHarlequinDrop"),
                HarlequinGameModuleConfig.harlequinWalkerView.addAndShowWildDrop(this._dropIndex, this._wildMultipliers),
                //HarlequinGameModuleConfig.harlequinScatterCollectorView.resetIndicators(htl.totalDuration()), // OBSOLETE?
                //() => HarlequinGameModuleConfig.harlequinSignView.resetHeadSpine()
            ], "+=" + 1.2);
            tl.add((this._scattersCollectedFSAfter === 2)? () => {} : () => HarlequinGameModuleConfig.harlequinSignView.enterMode(this._fromMode, this._toMode, false, undefined, undefined, true));

            //TODO: need to handle case where extra scatter is present
            // TODO: Add liting of leftovers
            tl.add(() => {
                this._hasWin = false;
            });
            tl.add([
                HarlequinGameModuleConfig.harlequinScatterCollectorView.playDelayedPlusOnePositions(this._freespinsAddCounter),
                () => {}
                ], "+=" + this._endDelay);
        }

        this._tl = tl;
        return tl;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        if(isActive && this._tl) {
            //GameRoundManager.detachAndPlayTimeline(this._tl);
            return this._tl;
        }
        else {
            if(this._hasWin) {
                return this.getAnimation();
            }
        }
        return null;
    }

    public prepare(data:HarlequinParsedGameData) {
        this._hasDropped = false;
        this._hasWin = !(data.wildDrop && data.wildDrop.every((value) => {
            return !value;
        }));
        this._wildMultipliers = data.wildMultipliers || [];
        this._scattersCollectedFSAfter = data.scattersCollectedFSAfter || 0;
        this._freespinsAddCounter = data.freespinsLeft - data.extraSpinsAwardedThisSpin;
        this._firstSpinWildDrop = data.firstSpinWildDrop;
        this._wildDrop = data.wildDrop || [false, false, false, false, false];
        this._fromMode = data.mode;
        this._toMode = data.nextMode;
    }

}